/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DiscogsArtistImagesInner
 */
export interface DiscogsArtistImagesInner {
    /**
     * 
     * @type {string}
     * @memberof DiscogsArtistImagesInner
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof DiscogsArtistImagesInner
     */
    resourceUrl: string;
}

/**
 * Check if a given object implements the DiscogsArtistImagesInner interface.
 */
export function instanceOfDiscogsArtistImagesInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "resourceUrl" in value;

    return isInstance;
}

export function DiscogsArtistImagesInnerFromJSON(json: any): DiscogsArtistImagesInner {
    return DiscogsArtistImagesInnerFromJSONTyped(json, false);
}

export function DiscogsArtistImagesInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): DiscogsArtistImagesInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'type': json['type'],
        'resourceUrl': json['resource_url'],
    };
}

export function DiscogsArtistImagesInnerToJSON(value?: DiscogsArtistImagesInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'type': value.type,
        'resource_url': value.resourceUrl,
    };
}

